<template>
  <div id="pers-tab14" name="hres31x-tab14" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tableTrainingData.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-book icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC19']['10'] }} ( {{ labels['HRES31XC19']['20'] }}  {{ index + 1 }} )</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC19']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.destrain }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC19']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ setDateOutput(value.dtetrain) }} - {{ setDateOutput(value.dtetren) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC19']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ value.desplace }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC19']['60'] }}</div>
              <div class="col-xs-6 data-text">{{ value.desinstu }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab14',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab14.vue?18bbb146